<template>
  <div class="template">
    <div class="search" style="display:block">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.orderNo"
                 placeholder="请输入订单号"
                 style="width: 150px;"
                 @on-enter="searchFn"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="用户id"
                 style="width: 80px;"
                 @on-enter="searchFn"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.referrerId"
                 placeholder="推荐人id"
                 style="width: 80px;"
                 @on-enter="searchFn"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="用户昵称"
                 style="width: 150px;"
                 @on-enter="searchFn"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.phone"
                 placeholder="请输入手机号"
                 style="width: 150px;"
                 @on-enter="searchFn"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.title"
                 placeholder="请输入商品"
                 style="width: 150px;"
                 @on-enter="searchFn"
          ></Input>
        </div>

        <div class="search-item">
          <Select v-model="search.factoryId"
                  clearable
                  style="width:100px;"
                  :label-in-value="true"
                  placeholder="制作工厂"
                  class="select"
          >
            <Option v-for="(item,index) in factoryList" :key="index" :value="item.id+''" :label="item.title">
            </Option>
          </Select>
        </div>
      </div>
      <div class="search-center">
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.status"
                  :label-in-value="true"
                  placeholder="请选择状态"
                  class="select"
          >
            <Option value="0" label="待付款"></Option>
            <Option value="100" label="待改价"></Option>
            <Option value="190" label="待设计"></Option>
            <Option value="200" label="设计待确认"></Option>
            <Option value="300" label="待制作"></Option>
            <Option value="1" label="待发货"></Option>
            <Option value="2" label="待收货"></Option>
            <Option value="5" label="已送达"></Option>
            <Option value="10" label="已收货"></Option>
            <Option value="-1" label="失败"></Option>
            <Option value="-2" label="已退款"></Option>
            <Option value="-9" label="异常"></Option>
            <Option value="-12" label="取消"></Option>
            <Option value="-13" label="自动取消"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.question"
                  :label-in-value="true"
                  placeholder="售后状态"
                  class="select"
          >
            <Option value="0" label="未售后"></Option>
            <Option value="1" label="待处理"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Date-picker
              ref="brithdayPicker"
              type="datetime"
              v-model="search.createTimeBegin"
              placeholder="请选择开始时间"
              style="width:150px"
          ></Date-picker>
        </div>
        <div class="search-item">
          <Date-picker
              ref="brithdayPicker"
              type="datetime"
              v-model="search.createTimeEnd"
              placeholder="请选择结束时间"
              style="width:150px"
          ></Date-picker>
        </div>
        <Checkbox v-model="search.process" true-value="1" false-value="0">待处理</Checkbox>
        <Checkbox v-model="search.payed" true-value="1" false-value="0">只查已付款</Checkbox>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      <Button
          style="width: 80px;margin-right: 10px;margin-bottom:5px"
          type="primary"
          icon="ios-download"
          @click="downloadOrders()"
      >下载
      </Button>
      </div>
    </div>
    <div class="table">
      <Table
          ref="selection"
          @on-select="selectSupplier"
          @on-select-cancel="selectSupplier"
          @on-select-all="selectSupplier"
          @on-select-all-cancel="selectSupplier"
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
              placement="top"
          ></Page>
        </template>
      </Table>
    </div>

    <Drawer title="" width="400" :closable="false" v-model="diyDom.showModal">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          {{ apiData.orderInfo.statusName }}
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            收货信息：
          </div>
          <div class="content-item-center">
            <p>{{ apiData.orderInfo.name }} {{ apiData.orderInfo.phone }}</p>
            <p>{{ apiData.orderInfo.address }}</p>
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            广告安装：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.install == 1 ? '上门安装' : '自行安装' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            配送方式：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.homeDelivery === 1 ? '送货上门' : '快递' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            买家备注：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.buyerRemark || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title" style="line-height: 30px;">
            快递信息：
          </div>
          <div class="content-item-center"
               v-if="apiData.orderInfo.homeDelivery === 0 && (apiData.orderInfo.status===1||apiData.orderInfo.status===3||apiData.orderInfo.status===4)">
            <Select clearable
                    style="width:100px;"
                    v-model="form.expressCompany"
                    @on-change="setCourierCompany"
                    allow-create
                    @on-create="handleCreate"
                    :label-in-value="true"
                    filterable
                    placeholder="请选择快递公司"
                    class="select"
            >
              <Option v-for="(item,index) in apiData.courierCompany" :key="index" :value="item.name">{{ item.name }}
              </Option>
            </Select>

            <Input clearable
                   v-model="form.deliveryNo"
                   placeholder="请输入快递单号"
                   style="width: 150px;"
            ></Input>
          </div>
          <div class="content-item-center" v-else-if="apiData.orderInfo.homeDelivery === 1">
            <Input v-model="form.expressCompany"
                   style="width: 150px;"
            ></Input>
          </div>
          <template v-else>
            <div class="content-item-center" style="line-height: 30px;"
                 v-if="apiData.orderInfo.expressCompany||apiData.orderInfo.deliveryNo">
              {{ apiData.orderInfo.expressCompany }} {{ apiData.orderInfo.deliveryNo }}
            </div>
            <div class="content-item-center" style="line-height: 30px;" v-else>无</div>
          </template>
        </div>
        <Divider dashed/>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            订单号：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.orderNo || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            购买商品：
          </div>
          <div class="content-item-center">
            <div class="content-item-center-box" v-for="(item,index) in apiData.orderInfo.details" :key="index">
              <div class="content-item-center-box-title">
                {{ item.title }}
              </div>
              <div class="content-item-center-box-content">
                数量：x{{ item.num }}
              </div>
              <div v-if="item.customTemplate == 2" class="content-item-center-box-content">
                模板：无需模版
              </div>
              <div v-else-if="item.customTemplate == 1" class="content-item-center-box-content">
                模板：自定义模板
              </div>
              <div v-else class="content-item-center-box-content">
                模板：{{ item.templateName }}
              </div>
              <!-- <div v-if="item.replaceWord" class="content-item-center-box-content">
                替换文本：{{item.replaceWord}}
              </div>
               <div v-if="item.uploadFile" class="content-item-center-box-content">
                上传文件：<a href="javascript:;" @click="lookFile(item.uploadFile)">{{item.uploadFile}}</a>
              </div> -->
              <div class="content-item-center-box-content" v-if="item.skuInfo">
                规格：{{ item.skuInfo }}
              </div>
              <div class="content-item-center-box-content" v-if="item.width">
                尺寸(宽*高)：{{ item.width }}mm * {{ item.height }}mm
              </div>
              <div class="content-item-center-box-content" v-if="item.processInfo">
                工序：{{ item.processInfo }}
              </div>
              <div v-if="item.status==-1">
                <div class="content-item-center-box-content">
                  设计确认状态：<span style="color:#FF0000">驳回</span>
                </div>
                <div class="content-item-center-box-content">
                  驳回原因：<span style="color:#FF0000">{{ item.reason }}</span>
                </div>
              </div>
              <div v-if="item.status==2">
                <div class="content-item-center-box-content">
                  设计确认状态：已确认
                </div>
              </div>
              <div v-if="item.status==1">
                <div class="content-item-center-box-content">
                  设计确认状态：待确认
                </div>
              </div>
              <div class="content-item-center-box-content">
                <Button v-if="item.status==0" style="width: 90px;color:#FFF;background-color: #2d8cf0"
                        @click="lookShop(item)">待设计
                </Button>
                <Button v-else style="width: 90px" @click="lookShop(item)">查看详情</Button>
              </div>
              <div v-if="apiData.orderInfo.status==100&&item.custom==1" class="content-item-center-box-price">
                ￥<input class="priceInput" @blur="setPrice(item)" v-model="item.price" type="number"/>x{{ item.num }}
              </div>
            </div>
            <p>共{{ apiData.orderInfo.details.length }}件商品</p>
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            商品金额：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.price || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.discountAmount">
          <div class="content-item-title">
            优惠金额：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.discountAmount || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            运费：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.deliveryFee || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.changeAmount">
          <div class="content-item-title">
            改价：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.changeAmount || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            实付金额：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.relAmount || '0' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.refundAmount">
          <div class="content-item-title">
            退款金额：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.refundAmount || '0' }}
          </div>
        </div>
        <Divider dashed/>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            下单时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.createTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.payTime">
          <div class="content-item-title">
            支付时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.payTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.sendTime">
          <div class="content-item-title">
            发货时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.sendTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.arriveTime">
          <div class="content-item-title">
            送达时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.arriveTime || '--' }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="apiData.orderInfo.completeTime">
          <div class="content-item-title">
            完成时间：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.completeTime || '--' }}
          </div>
        </div>
        <Divider dashed/>
        <div v-if="apiData.orderInfo.status==1">
          <!-- 待发货 -->
          <Button style="width: 90px">打单</Button>
          <Button type="primary" style="width: 90px; margin-left: 20px" @click="getOrderinfoSendOut">发货</Button>
        </div>
        <div v-if="apiData.orderInfo.status==100">
          <!-- 带改价 -->
          <Button style="width: 90px" @click="diyDom.showModal=false">返回</Button>
          <Button type="primary" @click="getEnsurePrice()" style="width: 90px; margin-left: 20px">提交</Button>
        </div>
      </div>
    </Drawer>
    <Drawer title="" width="400" :closable="true" v-model="diyDom.showDelivery">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          {{ apiData.orderInfo.statusName }}
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            收货信息：
          </div>
          <div class="content-item-center">
            <p>{{ apiData.orderInfo.name }} {{ apiData.orderInfo.phone }}</p>
            <p>{{ apiData.orderInfo.address }}</p>
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            买家备注：
          </div>
          <div class="content-item-center">
            {{ apiData.orderInfo.buyerRemark || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title" style="line-height: 30px;">
            快递信息：
          </div>
          <template>
            <div class="content-item-center" style="line-height: 30px;"
                 v-if="apiData.orderInfo.expressCompany||apiData.orderInfo.deliveryNo">
              {{ apiData.orderInfo.expressCompany }} {{ apiData.orderInfo.deliveryNo }}
            </div>
            <div class="content-item-center" style="line-height: 30px;" v-else>无</div>
          </template>
        </div>
        <div class="deliveryList-center" v-for="(item,index) in apiData.deliveryList" :key="index">
          <div class="updateTime">{{ item.time }}</div>
          <div class="deliveryInfo">{{ item.context }}</div>
          <div class="dian"></div>
        </div>
      </div>
    </Drawer>
    <!-- 商品详情 -->
    <Drawer title="" width="400" :closable="false" v-model="diyDom.showshopModal">
      <div class="Drawer-content" v-if="apiData.orderInfo">
        <div class="status">
          广告详情
        </div>
        <div class="Drawer-content-list">
          <img :src="diyData.shopInfo.img" style="width: 30%"/>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            名称：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.title }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            数量：
          </div>
          <div class="content-item-center">
            x {{ diyData.shopInfo.num }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            模板：
          </div>
          <div v-if="diyData.shopInfo.customTemplate == 2" class="content-item-center">
            无需模版
          </div>
          <div v-else-if="diyData.shopInfo.customTemplate == 1" class="content-item-center">
            自定义模板
          </div>
          <div v-else class="content-item-center">
            {{ diyData.shopInfo.templateName }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.skuInfo">
          <div class="content-item-title">
            规格：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.skuInfo }}
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.processInfo">
          <div class="content-item-title">
            工序：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.processInfo }}
          </div>
        </div>
        <Divider dashed/>

        <div v-if="diyData.shopInfo.customTemplate == 0">
          <div class="Drawer-content-list">
            <div class="content-item-title">
              模板编号：
            </div>
            <div class="content-item-center">
              {{ diyData.shopInfo.templateCode || '无' }}
            </div>
          </div>
          <div class="Drawer-content-list">
            <div class="content-item-title">
              模板源文件：
            </div>
            <div class="content-item-center" v-if="diyData.shopInfo.templateSourceFile">
              <a href="javascript:;" @click="lookFile(diyData.shopInfo.templateSourceFile)">下载模板源文件</a>
            </div>
            <div class="content-item-center" v-else>
              无
            </div>
          </div>
        </div>

        <div class="Drawer-content-list">
          <div class="content-item-title">
            用户替换文字：
          </div>
          <div class="content-item-center">
            {{ diyData.shopInfo.replaceWord || '无' }}
          </div>
        </div>
        <div class="Drawer-content-list">
          <div class="content-item-title">
            用户上传文件：
          </div>
          <div class="content-item-center">
            <a v-if="diyData.shopInfo.uploadFile" href="javascript:;" @click="lookFile(diyData.shopInfo.uploadFile)">下载文件</a>
            <span v-else>未上传文件</span>
          </div>
        </div>
        <div class="Drawer-content-list" v-if="diyData.shopInfo.designImg">
          <div class="content-item-title">
            设计预览：
          </div>
          <img
              :src="diyData.shopInfo.designImg"
              style="width: 30%; cursor: pointer;"
              @click="lookImg(diyData.shopInfo.designImg)"
          />
        </div>
        <div v-if="diyData.shopInfo.designFile" class="Drawer-content-list">
          <div class="content-item-title">
            设计源文件：
          </div>
          <div class="content-item-center">

            <a href="javascript:;" @click="lookFile(diyData.shopInfo.designFile)">下载设计源文件</a>
          </div>
        </div>
        <template v-if="apiData.orderInfo.status==190||apiData.orderInfo.status==200">
          <Divider dashed/>
          <div class="Drawer-content-list">
            <div class="content-item-title">
              提交设计：
            </div>
            <div class="content-item-center">
              <div class="upload-Img">
                <div v-if="formShop.designImg" class="look-img">
                  <img :src="formShop.designImg" style="width: 100%"/>
                  <div class="demo-upload-list-cover">
                    <Icon
                        type="ios-eye-outline"
                        @click.native="lookFile(formShop.designImg)"
                    ></Icon>
                    <Icon
                        type="ios-trash-outline"
                        @click.native="deleteFile('designImg')"
                    ></Icon>
                  </div>
                </div>
                <template v-else>
                  <Upload
                      :action="uploadUrl"
                      :headers="headers"
                      :on-error="uploadErr"
                      :on-success="(value) => uploadSuccess('designImg', value)"
                      name="file"
                      :show-upload-list="false"
                  >
                    <div class="upload-btn">
                      <Icon
                          type="ios-cloud-upload"
                          size="52"
                          style="color: #3399ff"
                      ></Icon>
                      <p>上传图片</p>
                    </div>
                  </Upload>
                </template>
              </div>
            </div>
          </div>
          <div class="Drawer-content-list">
            <div class="content-item-title">
              源文件：
            </div>
            <div class="content-item-center">
              <template v-if="formShop.designFile">
                <span style="margin-left: 10px;color:#2a82e4;cursor: pointer;"
                      @click="lookFile(formShop.designFile)">查看</span>
                <span style="margin-left: 10px;color:#ff0000;cursor: pointer;" @click="deteleDesignFile()">删除</span>
              </template>
              <template v-else>
                <Upload
                    :action="tempUploadUrl"
                    :headers="headers"
                    :on-progress="handleProgress"
                    :on-error="uploadErr"
                    :on-success="(value) => uploadSuccess('designFile', value)"
                    name="file"
                    :show-upload-list="false"
                >
                  <Button style="margin-left: 10px" icon="ios-cloud-upload">上传源文件</Button>
                </Upload>
                <!-- 进度条 -->
                <Progress
                    v-if="progressPercent >= 0"
                    :percent="progressPercent"
                    :status="progressStatus"
                />
                <p v-if="progressPercent >= 0">{{ progressPercent }}%</p>
              </template>
            </div>
          </div>
          <div class="Drawer-content-list" v-if="diyData.shopInfo.reason">
            <div class="content-item-title">
              用户反馈：
            </div>
            <div class="content-item-center">
              {{ diyData.shopInfo.reason || '无' }}
            </div>
          </div>

          <Divider dashed/>
          <div>
            <Button style="width: 90px" @click="diyDom.showshopModal=false">返回</Button>
            <Button v-if="apiData.orderInfo.status==190" type="primary" @click="getupDesign()"
                    style="width: 90px; margin-left: 20px">提交设计
            </Button>
            <Button v-if="apiData.orderInfo.status==190" type="primary" @click="getupEnsureDesign()"
                    style="width: 90px; margin-left: 20px">提交并确认
            </Button>
            <Button v-if="apiData.orderInfo.status==200" type="primary" @click="getupEnsureDesign()"
                    style="width: 90px; margin-left: 20px">确认设计
            </Button>
          </div>
        </template>
      </div>
    </Drawer>
    <Modal v-model="showChangeModal" :mask="false" title="改价">
      <Form
          :model="changeForm"
          :label-width="100">
        <FormItem label="改价金额：">
          <InputNumber
              placeholder="请输入一口价金额"
              :min="0.01"
              :max="1000000"
              v-model="changeForm.price"
              style="max-width:120px;width:100%"/>
          <label>该价格为用户最终支付金额</label>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="changePrice">提交</Button>
        <Button @click="showChangeModal = false">取消</Button>
      </template>
    </Modal>
    <Modal v-model="showRefundModal" :mask="false" title="退款">
      <Form
          :model="refundForm"
          :label-width="100">
        <FormItem label="退款金额：">
          <InputNumber
              placeholder="请输入退款金额"
              :min="0.01"
              :max="1000000"
              v-model="refundForm.refundAmount"
              style="max-width:120px;width:100%"/>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="refundAmount">提交</Button>
        <Button @click="showRefundModal = false">取消</Button>
      </template>
    </Modal>
    <Modal v-model="showMakeModal" :mask="false" title="制作">
      <Form
          :model="makeForm"
          :label-width="100">
        <div style="text-align: center;margin-bottom: 5px;">
          <h3 style="color: #333">请先确认当前产品设计图，用户都已经确认完成</h3>
          <h3 style="color: #333">一旦开始制作，将无法修改设计图</h3>
        </div>
        <FormItem label="制作工厂" prop="factoryId">
          <Select v-model="makeForm.factoryId"
                  clearable
                  style="width:250px;"
                  :label-in-value="true"
                  placeholder="请选择工厂"
                  class="select"
          >
            <Option v-for="(item,index) in factoryList" :key="index" :value="item.id+''" :label="item.title">
            </Option>
          </Select>
        </FormItem>
      </Form>
      <template #footer>
        <Button type="primary" @click="submitMake">提交</Button>
        <Button @click="showMakeModal = false">取消</Button>
      </template>
    </Modal>
    <Modal
        footer-hide
        v-model="previewImgShow"
        @on-cancel="previewImgShow=false">
      <img :src="previewImgUrl" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import {
  apiArriveOrder, apiChangeComment,
  apiChangeDetailPrice,
  apiChangePrice,
  apiEnsurePrice, apiMarkNotNew,
  apiOrderDelete,
  apiOrderinfoInfo,
  apiOrderinfoList,
  apiOrderinfoSendMake,
  apiOrderinfoSendOut,
  apiOrderinfoSubmitDesign,
  apiRefundAmount,
  apiOrderinfoExport
} from '@/api/order-records.js'
import { getDateTime } from '@/libs/util'
import { apiAdFactoryList } from '@/api/system/account-manage'
import { downloadByResponse } from '@/utils/download'

export default {
  name: 'order-records',
  data () {
    return {

      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      tempUploadUrl: process.env.VUE_APP_API_URL + '/producttemp/upload-file',
      progressPercent: -1, // -1 表示未开始上传
      progressStatus: 'active', // 'active' | 'success' | 'wrong'
      orderNos: '',
      makeCompany: '',
      factoryList: [],
      showChangeModal: false,
      showMakeModal: false,
      previewImgShow: false,
      previewImgUrl: '',
      showRefundModal: false,
      showOperationColumn: true,
      changeForm: {
        orderNo: '',
        price: ''
      },
      makeForm: {
        orderNo: '',
        factoryId: ''
      },
      refundForm: {
        orderNo: '',
        refundAmount: ''
      },
      search: {
        nickname: '',
        orderNo: '',
        telecom: '',
        payNo: '',
        userId: '',
        referrerId: '',
        phone: '',
        type: '',
        status: '',
        factoryId: '',
        pageNo: 1,
        pageSize: 10,
        createTimeEnd: '',
        process: 0,
        payed: 0,
        createTimeBegin: ''
      },
      diyDom: {
        showModal: false,
        showDelivery: false,
        showshopModal: false
      },
      form: {
        expressCompany: '',
        expressCompanyCode: '',
        deliveryNo: '',
        orderNo: ''
      },
      formShop: {
        designFile: '',
        designImg: ''
      },
      diyData: {
        orderNos: '',
        orderNo: '',
        columns: [
          {
            title: '下单时间/支付时间',
            width: '180px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.createTime),
                h('p', params.row.payTime)
              ])
            }
          },
          {
            title: '昵称-id/手机号',
            width: '160px',
            key: 'phone',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.search.userId = params.row.userId
                      this.searchFn()
                    }
                  }
                }, params.row.nickname + ' - ' + params.row.userId),
                h('p', params.row.phone)
              ])
            }
          },
          {
            title: '推荐人/id',
            width: '100px',
            key: 'phone',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.search.referrerId = params.row.referrerId
                      this.searchFn()
                    }
                  }
                }, params.row.referrerName),
                h('p', params.row.referrerId)
              ])
            }
          },
          {
            title: '购买商品',
            width: '200px',
            render: (h, params) => {
              var title = params.row.title

              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.apiData.orderInfo = ''
                      this.diyData.orderNo = params.row.orderNo
                      this.diyDom.showModal = true
                      this.getOrderInfo()
                    }
                  }
                }, title
                ),
                // 新增的新订单标记按钮
                params.row.newOrder === 1 ? h('Button', {
                  props: {
                    type: 'primary',
                    shape: 'circle',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation() // 阻止事件冒泡
                      var that = this
                      apiMarkNotNew({ orderNo: params.row.orderNo }).then(res => {
                        that.$Message.success('操作成功')
                        that.getTableList()
                      })
                    }
                  }
                }, '新') : null
              ])
            }
          },
          {
            title: '状态',
            width: '80px',
            key: 'status',
            render: (h, params) => {
              var color = ''
              switch (params.row.status) {
                case 0:
                  color = '#A6A6A6'
                  break
                case 1:
                  color = 'rgba(204,56,184,0.73)'
                  break
                case 2:
                case 190:
                  color = '#2232ea'
                  break
                case 100:
                case 200:
                case 300:
                  color = 'rgba(204,56,184,0.73)'
                  break
                case 5:
                  color = '#2aace4'
                  break
                case 10:
                  color = '#2A82E4'
                  break
                case -1:
                  color = '#ff0000'
                  break
                case -2:
                  color = '#ff0000'
                  break
                case -9:
                  color = '#ff0000'
                  break

                case -12:
                  color = '#A6A6A6'
                  break
                case -13:
                  color = '#A6A6A6'
                  break
              }
              return h('div', [
                h('span', {
                  style: {
                    'color': color,
                    'border': '1px solid ' + color,
                    'border-radius': '3px'
                  }
                }, params.row.statusName)
              ])
            }
          },
          {
            title: '售后',
            width: '80px',
            render: (h, params) => {
              if (params.row.question === 1) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'text',
                      size: 'small'
                    },
                    style: {
                      'color': '#2A82E4',
                      'border': '1px solid #2A82E4',
                      'border-radius': '3px'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'after-sales-manage',
                          query: {
                            orderNo: params.row.orderNo
                          }
                        })
                      }
                    }
                  }, '待处理')
                ])
              } else {
                return h('div', [
                  h('p', '')
                ])
              }
            }
          },
          {
            title: '商品金额',
            width: '96px',
            key: 'price'
          },
          // {
          //   title: '优惠金额',
          //   width: '100px',
          //   key: 'discountAmount'
          // },
          {
            title: '优惠券',
            width: '80px',
            key: 'couponAmount'
          },
          {
            title: '运费',
            width: '80px',
            key: 'deliveryFee'
          },
          {
            title: '改价',
            width: '80px',
            key: 'changeAmount'
          },
          {
            title: '实付',
            width: '80px',
            key: 'relAmount'
          },
          {
            title: '退款',
            width: '80px',
            key: 'refundAmount'
          },
          {
            title: '用户备注',
            width: '150px',
            key: 'buyerRemark'
          },
          {
            title: '商家备注',
            width: '150px',
            key: 'comment',
            render: (h, params) => {
              return h('div', [
                h('span', params.row.comment || '--'),
                h('Button', {
                  props: {
                    type: 'text',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      var that = this
                      var input
                      // 这里可以添加修改备注的逻辑，例如打开一个modal输入框
                      this.$Modal.confirm({
                        title: '修改商家备注',
                        render: (h) => {
                          input = h('Input', {
                            props: {
                              value: params.row.comment,
                              placeholder: '请输入商家备注',
                              autosize: { minRows: 2, maxRows: 5 },
                              type: 'textarea'
                            },
                            on: {
                              input: (val) => {
                                input.componentInstance.currentValue = val
                              }
                            }
                          })
                          return h('div', [input])
                        },
                        onOk: () => {
                          that.changeComment(params.row.orderNo, input.componentInstance.currentValue)
                        }
                      })
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-create',
                      size: '16'
                    }
                  })
                ])
              ])
            }
          },
          {
            title: '配送方式',
            width: '96px',
            render: (h, params) => {
              if (params.row.homeDelivery === 1) {
                return h('div', [
                  h('p', '送货上门')
                ])
              } else {
                return h('div', [
                  h('p', '快递')
                ])
              }
            }
          },
          {
            title: '收货人/手机号',
            width: '126px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.name),
                h('p', params.row.phone)
              ])
            }
          },
          {
            title: '收货地址',
            width: '200px',
            key: 'address'
          },
          {
            title: '制作工厂',
            width: '160px',
            key: 'factoryTitle'
          },
          // 修改订单号/支付单号列的render函数
          {
            title: '订单号/支付单号',
            width: '210px',
            render: (h, params) => {
              return h('div', [
                h('p', {
                  style: {
                    cursor: 'pointer',
                    color: '#2d8cf0'
                  },
                  on: {
                    click: () => {
                      this.copyToClipboard(params.row.orderNo)
                    }
                  }
                }, params.row.orderNo),
                h('p', {
                  style: {
                    cursor: 'pointer',
                    color: '#2d8cf0'
                  },
                  on: {
                    click: () => {
                      this.copyToClipboard(params.row.payNo)
                    }
                  }
                }, params.row.payNo)
              ])
            }
          },
          {
            title: '发货时间/完成时间',
            width: '180px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.sendTime),
                h('p', params.row.completeTime)
              ])
            }
          },
          {
            title: '操作',
            width: '240px',
            fixed: 'right',
            key: 'operation',
            renderHeader: (h, params) => {
              return h('div', {
                style: {
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                },
                on: {
                  click: () => {
                    this.showOperationColumn = !this.showOperationColumn
                    // 动态更新列宽度
                    const operationColumn = this.diyData.columns.find(col => col.key === 'operation')
                    if (operationColumn) {
                      operationColumn.width = this.showOperationColumn ? '240px' : '40px'
                    }
                  }
                }
              }, [
                h('span', this.showOperationColumn ? '操作' : ''),
                h('Icon', {
                  props: {
                    type: this.showOperationColumn ? 'md-eye' : 'md-eye-off',
                    size: '16'
                  },
                  style: {
                    marginLeft: this.showOperationColumn ? '5px' : '0',
                    transition: 'margin-left 0.3s'
                  }
                })
              ])
            },
            render: (h, params) => {
              if (!this.showOperationColumn) {
                return h('div', {
                  style: {
                    textAlign: 'center'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-more',
                      size: '18'
                    },
                    style: {
                      cursor: 'pointer'
                    },
                    on: {
                      click: () => {
                        this.showOperationColumn = true
                        // 更新列宽度
                        const operationColumn = this.diyData.columns.find(col => col.key === 'operation')
                        if (operationColumn) {
                          operationColumn.width = '240px'
                        }
                      }
                    }
                  })
                ])
              }
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status === 0 || params.row.status === 100 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.changeForm.orderNo = params.row.orderNo
                      this.showChangeModal = true
                    }
                  }
                },
                '改价'
                ),
                // h('Button', {
                //   props: {
                //     size: 'small'
                //   },
                //   style: {
                //     marginRight: '10px',
                //     width: '60px',
                //     fontSize: '14px'
                //   },
                //   on: {
                //     click: () => {
                //       var tatgetRouter = this.$router.resolve({
                //         name: 'order-blackmail',
                //         query: {
                //           orderNos: params.row.orderNo
                //         }
                //       })
                //       window.open(tatgetRouter.href, '_blank')
                //     }
                //   }
                // },
                // '打单'
                // ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status === 300 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.makeCompany = ''
                      this.showMakeModal = true
                      this.makeForm.orderNo = params.row.orderNo
                    }
                  }
                },
                '制作'
                ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status === 1 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.apiData.orderInfo = ''
                      this.diyData.orderNo = params.row.orderNo
                      this.form.orderNo = params.row.orderNo
                      this.diyDom.showModal = true
                      this.getOrderInfo()
                    }
                  }
                },
                '发货'
                ),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status === 2 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '是否确认送达？',
                        onOk: () => {
                          var that = this
                          apiArriveOrder({
                            orderNo: params.row.orderNo
                          }).then(res => {
                            that.$Message.success('操作成功')
                            that.getTableList()
                          })
                        }
                      })
                    }
                  }
                },
                '送达'
                ),
                h('Button', {
                  props: {
                    type: params.row.status === 190 ? 'primary' : '',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status != 1 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.apiData.orderInfo = ''
                      this.diyData.orderNo = params.row.orderNo
                      this.diyDom.showModal = true
                      this.getOrderInfo()
                    }
                  }
                },
                params.row.status === 190 ? '设计' : '详情'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status == 2 || params.row.status == 10 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.apiData.orderInfo = ''
                      this.apiData.deliveryList = []
                      this.diyData.orderNo = params.row.orderNo
                      this.diyDom.showDelivery = true
                      this.getOrderInfo()
                      ({ orderNo: params.row.orderNo, type: 1 }).then(res => {
                        if (res.data.deliveryInfo) {
                          this.apiData.deliveryList = JSON.parse(res.data.deliveryInfo)
                        }
                      })
                    }
                  }
                },
                '物流'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status > 0 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      this.showRefundModal = true
                      this.refundForm.orderNo = params.row.orderNo
                      this.refundForm.refundAmount = ''
                    }
                  }
                },
                '退款'
                ),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px',
                    display: params.row.status === 0 || params.row.status === -12 || params.row.status === -13 ? '' : 'none' // 修改: 添加状态判断
                  },
                  on: {
                    click: () => {
                      apiOrderDelete({ orderNo: params.row.orderNo }).then(res => {
                        if (res.code !== 200) {
                          return this.$Modal.error({ title: '提示', content: res.msg })
                        } else {
                          this.$Message.success('操作成功')
                          this.getTableList()
                        }
                      })
                    }
                  }
                },
                '删除'
                )
              ])
            }
          }
        ],
        shopInfo: ''
      },
      apiData: {
        total: 0,
        tableList: [],
        orderInfo: '',
        countriesAllList: [],
        courierCompany: [],
        deliveryList: []
      }
    }
  },
  methods: {
    /**
     * 复制文本到剪切板
     * @param {string} text - 需要复制的文本
     */
    copyToClipboard (text) {
      // 检查文本是否为空
      if (!text) {
        this.$Message.warning('没有可复制的内容')
        return
      }

      // 优先使用现代 Clipboard API
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$Message.success('复制成功: ' + text)
          })
          .catch(err => {
            console.error('复制失败:', err)
            this.$Message.error('复制失败: ' + err)
            // 降级到传统方法
            this.fallbackCopyTextToClipboard(text)
          })
      } else {
        // 降级到传统方法
        this.fallbackCopyTextToClipboard(text)
      }
    },

    /**
     * 传统方式复制文本到剪切板（兼容性处理）
     * @param {string} text - 需要复制的文本
     */
    fallbackCopyTextToClipboard (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      // 防止在iOS Safari中缩放
      textarea.style.fontSize = '12pt'
      textarea.style.position = 'fixed'
      textarea.style.top = '-1000px'
      textarea.style.left = '-1000px'

      document.body.appendChild(textarea)
      textarea.select()

      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$Message.success('复制成功: ' + text)
        } else {
          this.$Message.error('复制失败')
        }
      } catch (err) {
        console.error('复制失败:', err)
        this.$Message.error('复制失败: ' + err)
      }

      document.body.removeChild(textarea)
    },

    getFactoryList () {
      var opt = {
        pageNo: 1,
        pageSize: 1000
      }
      apiAdFactoryList(opt).then(res => {
        this.factoryList = res.data.list
      })
    },
    /**
     * 下载订单数据
     */
    downloadOrders () {
      this.$store.commit('setSpinShow', true)

      // 格式化日期参数
      const params = { ...this.search }
      if (params.createTimeBegin) {
        params.createTimeBegin = getDateTime(params.createTimeBegin)
      }
      if (params.createTimeEnd) {
        params.createTimeEnd = getDateTime(params.createTimeEnd)
      }

      apiOrderinfoExport(params)
        .then(response => {
          downloadByResponse(response, '订单记录导出')
          this.$Message.success('导出成功')
        })
        .catch(error => {
          console.error('订单导出失败:', error)
          this.$Message.error('导出失败，请重试')
        })
        .finally(() => {
          this.$store.commit('setSpinShow', false)
        })
    },
    /**
     * 退款
     */
    refundAmount () {
      if (!this.refundForm.refundAmount) {
        this.$Notice.error({
          title: '错误',
          desc: '请输入退款金额'
        })
        return false
      }
      apiRefundAmount(this.refundForm).then(res => {
        if (res.code !== 200) {
          return this.$Modal.error({ title: '提示', content: res.msg })
        } else {
          this.$Message.success(res.msg)
          this.showRefundModal = false
          this.getTableList()
        }
      })
    },
    changeComment (orderNo, comment) {
      var param = {
        orderNo: orderNo,
        comment: comment
      }
      apiChangeComment(param).then(res => {
        if (res.code !== 200) {
          return this.$Modal.error({ title: '提示', content: res.msg })
        } else {
          this.$Message.success(res.msg)
          this.showChangeModal = false
          this.getTableList()
        }
      })
    },
    changePrice () {
      if (!this.changeForm.price || this.changeForm.price <= 0) {
        this.$Notice.error({
          title: '错误',
          desc: '请输入价格'
        })
        return false
      }
      apiChangePrice(this.changeForm).then(res => {
        if (res.code !== 200) {
          return this.$Modal.error({ title: '提示', content: res.msg })
        } else {
          this.$Message.success(res.msg)
          this.showChangeModal = false
          this.getTableList()
        }
      })
    },
    submitMake () {
      if (!this.makeForm.factoryId) {
        this.$Notice.warning({
          title: '警告',
          desc: '请选择工厂'
        })
        return false
      }
      apiOrderinfoSendMake(this.makeForm).then(res => {
        if (res.code !== 200) {
          return this.$Modal.error({ title: '提示', content: res.msg })
        } else {
          this.$Message.success(res.msg)
          this.showMakeModal = false
          this.getTableList()
        }
      })
    },
    // 上传进度回调
    handleProgress (event, file, fileList) {
      if (event.lengthComputable) {
        this.progressPercent = Math.floor((event.loaded / event.total) * 100)
      }
    },
    selectSupplier (e) {
      var orderNos = e.map(res => {
        return res.orderNo
      })
      this.diyData.orderNos = orderNos.join(',')
    },
    deteleDesignFile () {
      this.formShop.designFile = ''
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
    },
    uploadSuccess (type, res, index = 0) {
      if (res.code != 200) {
        this.progressStatus = 'wrong'
        return this.$Modal.error({ title: '提示', content: res.msg })
      }
      this.$Message.success('文件上传成功')
      this.progressStatus = 'success'
      if (type == 'designFile') {
        this.formShop.designFile = res.data.fileUrl
      } else if (type == 'designImg') {
        this.formShop.designImg = res.data.fileUrl
      }
    },
    // 文件上传失败
    uploadErr () {
      this.$Spin.hide()
      this.progressStatus = 'wrong'
      this.$Modal.error({
        title: '提示',
        content: '文件上传失败，请重试'
      })
    },

    // 查看文件
    lookFile (url) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.target = '_blank'
      a.href = url
      a.click()
      document.body.removeChild(a)
    },
    lookImg (url) {
      this.previewImgUrl = url
      this.previewImgShow = true
    },
    // 删除文件
    deleteFile (type, index) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          if (type == 'designFile') {
            this.formShop.designFile = ''
          } else if (type == 'designImg') {
            this.formShop.designImg = ''
          }
        }
      })
    },
    batchBlackmail () {
      if (this.diyData.orderNos == '') {
        return this.$Message.error('请选择订单')
      }
      var tatgetRouter = this.$router.resolve({
        name: 'order-blackmail',
        query: {
          orderNos: this.diyData.orderNos
        }
      })
      window.open(tatgetRouter.href, '_blank')
    },
    getCourierCompany () {
      var that = this
      axios.get('https://manage.dianggg.com/utils/courierCompany.js').then(function (response) {
        console.log(response.data)
        that.apiData.courierCompany = response.data
      })
    },
    setCourierCompany () {
      var that = this
      this.apiData.courierCompany.forEach(v => {
        if (v.name == that.form.expressCompany) {
          that.form.expressCompanyCode = v.value
        }
      })
    },
    setPrice (item) {
      console.log(item)
      var obj = {
        detailId: item.id,
        price: item.price,
        orderNo: this.diyData.orderNo
      }
      apiChangeDetailPrice(obj).then(res => {
        // this.$Message.success('修改成功')
      })
    },
    getEnsurePrice () {
      var obj = {
        orderNo: this.diyData.orderNo
      }
      apiEnsurePrice(obj).then(res => {
        this.$Message.success('修改成功')
        this.diyDom.showModal = false
        this.searchFn()
      })
    },
    handleCreate (val) {
      var that = this
      this.form.expressCompany = val
      this.apiData.courierCompany.push({
        value: '',
        name: val
      })
    },
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      opt.createTimeBegin = getDateTime(this.search.createTimeBegin)
      opt.createTimeEnd = getDateTime(this.search.createTimeEnd)
      apiOrderinfoList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    getOrderInfo () {
      apiOrderinfoInfo({ orderNo: this.diyData.orderNo }).then(res => {
        this.apiData.orderInfo = res.data
        if (res.data.homeDelivery === 1) {
          this.form.expressCompany = '自主配送'
        }
      })
    },
    getOrderinfoSendOut () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认发货？',
        onOk: () => {
          console.log({ ...that.form })
          apiOrderinfoSendOut({ ...that.form }).then(res => {
            that.$Message.success('发货成功')
            that.diyDom.showModal = false
            that.getTableList()
          })
        }
      })
    },
    lookShop (row) {
      console.log(row)
      this.formShop = {
        designFile: row.designFile,
        designImg: row.designImg
      },
      this.diyData.shopInfo = row
      this.diyDom.showshopModal = true
      this.progressPercent = -1 // -1 表示未开始上传
      this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
    },
    getupEnsureDesign () {
      this.getupDesign(true)
    },
    getupDesign (ensure) {
      var obj = {
        orderNo: this.diyData.orderNo,
        designFile: this.formShop.designFile,
        designImg: this.formShop.designImg,
        detailId: this.diyData.shopInfo.id,
        ensureDesign: 0
      }
      if (ensure) {
        obj.ensureDesign = 1
      }
      const that = this
      apiOrderinfoSubmitDesign(obj).then(res => {
        this.$Message.success('设计图提交成功')
        this.diyDom.showshopModal = false
        this.progressPercent = -1 // -1 表示未开始上传
        this.progressStatus = 'active' // 'active' | 'success' | 'wrong'
        that.getTableList()
      })
    }
  },
  mounted () {
    const userId = this.$route.query.userId
    if (userId) {
      this.search.userId = userId
    }
    this.getTableList()
    this.getCourierCompany()
    this.getFactoryList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;

  // 移动端适配
  @media (max-width: 768px) {
    padding: 5px;

    .search {
      .search-center {
        flex-direction: column;
        align-items: stretch;

        .search-item {
          margin-bottom: 5px;
        }
      }
    }

    .table {
      overflow-x: auto;

      ::v-deep .ivu-table {
        font-size: 11px;

        th, td {
          padding: 0px;
        }

        .ivu-table-column {
          white-space: nowrap;
        }
      }
    }

    .Drawer-content {
      .status {
        font-size: 20px;
        margin-bottom: 10px;
      }

      .Drawer-content-list {
        margin-bottom: 10px;

        .content-item-title,
        .content-item-center {
          font-size: 11px;
          width: auto;
        }

        .content-item-center-box {
          padding-bottom: 8px;
          margin-bottom: 8px;

          .content-item-center-box-title {
            font-size: 13px;
            margin-bottom: 4px;
          }

          .content-item-center-box-content {
            font-size: 11px;
            margin-bottom: 2px;
          }
        }
      }
    }
  }
}

.button-border {
  margin-right: 10px;

}

.Drawer-content {
  width: 100%;

  .status {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 34.75px;
    color: rgba(212, 48, 48, 1);
    text-align: left;
    margin-bottom: 15px;
  }

  .Drawer-content-list {
    width: 100%;
    margin-bottom: 15px;
    display: flex;

    .content-item-title {
      width: 140px;
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 17.38px;
      color: rgba(56, 56, 56, 1);
      text-align: left;
    }

    .content-item-center {
      width: 365px;
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0px;
      color: rgba(56, 56, 56, 1);
      text-align: left;

      p {
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0px;
        color: rgba(56, 56, 56, 1);
        text-align: left;
      }

      p.name {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 20.27px;
        color: rgba(0, 0, 0, 1);
      }

      .content-item-center-box {
        width: 100%;
        padding: 0px 0 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
        margin-bottom: 10px;
        position: relative;

        .content-item-center-box-title {
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0px;
          line-height: 20.27px;
          color: rgba(0, 0, 0, 1);
          margin-bottom: 5px;
        }

        .content-item-center-box-content {
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 17.38px;
          color: rgba(128, 128, 128, 1);
          margin-bottom: 3px;
        }

        .content-item-center-box-price {
          position: absolute;
          top: 50%;
          right: 0px;
          transform: translateY(-50%);

          .priceInput {
            width: 50px;
            margin: 0px 5px;
          }
        }
      }
    }
  }
}

.deliveryList-center {
  width: 100%;
  padding: 0px 10px 20px;
  box-sizing: border-box;
  border-left: 1px solid #FD7247;
  position: relative;

}

.updateTime {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.deliveryInfo {
  font-size: 14px;
  color: #333;
}

.dian {
  position: absolute;
  top: -4px;
  left: -4px;
  width: 6px;
  height: 6px;
  background: #FD7247;
  border-radius: 50%;
  display: block;
}

.upload-Img {
  width: 100px;
  height: 100px;

  .look-img {
    margin-left: 0px;
    width: 100px;
    height: 100px;
    text-align: center;

    img {
      margin-left: 0px;
    }

    .demo-upload-list-cover {
      line-height: 100px;
    }

    .demo-upload-list-cover i {
      line-height: 100px;
    }
  }

  .upload-Img {
    .demo-upload-list-cover i {
      line-height: normal;
    }
  }

  .upload-btn {
    padding-top: 15px;
    width: 100px;
    height: 100px;
    text-align: center;

    p {
      width: 100%;
      text-align: center !important;
    }
  }
}

.ivu-table-cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

</style>
